export default __webpack_public_path__ + "static/visually4-a3a69130360668c8eb095f95f35219ea.png";